import patch from './patch';

/**
 * Hide location suggestion dropdown in InputLocation component.
 */
export default () => (dispatch) => {
  dispatch(patch({
    ui: { locationSuggestions: undefined },
  }));
};
